export const FETCH_COURSE_TYPES = {
  START: 'START_FETCH_COURSE_TYPES',
  COMPLETE: 'COMPLETE_FETCH_COURSE_TYPES',
  FAIL: 'FAIL_FETCH_COURSE_TYPES',
  CLEANUP: 'CLEANUP_FETCH_COURSE_TYPES',
}

export const ADD_COURSE_TYPE = 'ADD_COURSE_TYPE'
export const RENAME_COURSE_TYPE = 'RENAME_COURSE_TYPE'

export const RESET_COURSE_TYPE_TREE = 'RESET_COURSE_TYPE_TREE'

export const SET_DATA_FOR_RENAMING_COURSE_TYPE =
  'SET_DATA_FOR_RENAMING_COURSE_TYPE'

export const SET_IS_CURATION_ENABLED_COURSE_TYPE = {
  START: 'START_SET_IS_CURATION_ENABLED_COURSE_TYPE',
  COMPLETE: 'COMPLETE_SET_IS_CURATION_ENABLED_COURSE_TYPE',
  FAIL: 'FAIL_SET_IS_CURATION_ENABLED_COURSE_TYPE',
}

export const DELETE_COURSE_TYPE = {
  START: 'START_DELETE_COURSE_TYPE',
  COMPLETE: 'COMPLETE_DELETE_COURSE_TYPE',
  FAIL: 'FAIL_DELETE_COURSE_TYPE',
}

export const REPLACE_COURSE_TYPE = {
  START: 'START_REPLACE_COURSE_TYPE',
  COMPLETE: 'COMPLETE_REPLACE_COURSE_TYPE',
  FAIL: 'FAIL_REPLACE_COURSE_TYPE',
}

export const REVERT_REPLACE_COURSE_TYPE = {
  START: 'START_REVERT_REPLACE_COURSE_TYPE',
  COMPLETE: 'COMPLETE_REVERT_REPLACE_COURSE_TYPE',
  FAIL: 'FAIL_REVERT_REPLACE_COURSE_TYPE',
}

export const MOVE_COURSE_TYPES = 'MOVE_COURSE_TYPES'

export const SAVE_COURSE_TYPES = {
  START: 'START_SAVE_COURSE_TYPES',
  COMPLETE: 'COMPLETE_SAVE_COURSE_TYPES',
  FAIL: 'FAIL_SAVE_COURSE_TYPES',
}

export const EXPAND_COURSE_TYPE_MAIN_TREE_KEYS =
  'EXPAND_COURSE_TYPE_MAIN_TREE_KEYS'

export const EXPAND_COURSE_TYPE_SUPPORTING_TREE_KEYS =
  'EXPAND_COURSE_TYPE_SUPPORTING_TREE_KEYS'
